<template>
  <div v-if="isAuthenticated === true">
    <div class="content">
      <div class="main q-mt-xl">
        <div class="main-card">
          <img src="../../../public/Rectangle 14.png" alt="nature" />
          <div class="wrapper">
            <div class="para">
              <span>Email Notification</span>
              <span>Free</span>
            </div>
            <div class="bottom">
              <span
                ><i class="material-icons" style="margin-right: 5px;"
                  >&#xe569;</i
                ></span
              >
              <span>On Time</span>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="head">
            <span>Price Tracker</span><br />
            <span style="font-size: large"
              ><strong>Notification Setting</strong></span
            >
          </div>
          <div class="head-content">
            <!-- <div class="head-img"></div> -->
            <img src="../../../public/Group 30.png" class="small" />
            <div class="head-card head-img">
              <span class="card-para"
                >“Price Watch Notification Service will send you periodic mail
                informing various details which are very useful for running the
                business”
              </span>
              <div class="head-sub">
                <span>Price Tracker</span>
                <span>Notification Settings</span>
              </div>
            </div>

            <div
              class="head-card"
              style="position: relative;
    top: 72px;    z-index: 1; display: flex;"
            >
              <div class="toggle">
                <p class="label-heading">Turn On</p>

                <q-toggle
                  v-model="notification_service"
                  style=" margin: 0;
    margin-top: auto;"
                  label="Notification"
                  left-label
                ></q-toggle>
              </div>
            </div>
          </div>
          <q-btn
            @click="on_submit"
            class="col-12 butt"
            color="primary"
            label="Save Preferences"
          ></q-btn>
        </div>
      </div>
      <div class="submain"></div>
    </div>
    <!-- <div  class="hea">
        <h4>Price Watch Notification Service</h4>
        </div>
        <div class="matter">
            <p>Price Watch Notification Service will send you periodic mail informing various details which are very useful for running the business. This involves change of competiotors prices, customer feedback and many other advanced analytical features which will keep ahead than your competitors. Our Machine Learning Algorithms will continuously monitor your competitors while you are away and taking care of other important things. </p>
        
        <div class="toggle">
          <p>Do you wish to add notification for price change?</p>
       <q-toggle
        v-model="notification_service"
        label="Notifications"
        left-label
      ></q-toggle>
        </div>
        </div> -->
    <!-- <div v-if="notification_service===true" class="matte">
            <h6>Do you want to activate these features </h6>
      <q-checkbox
        v-model="daily_update"
        color="secondary"
        label="Do you wish to have daily update of competitors price change via other channels including Mail?"
        true-value="yes"
        false-value="no"
      ></q-checkbox>
      <q-checkbox
        v-model="customize_update"
        color="secondary"
        label="Do you wish to customize update as per your preferance?"
        true-value="yes"
        false-value="no"
      ></q-checkbox>
       <q-checkbox
        v-model="alert"
        color="secondary"
        label="Do you wish to get alert for sudden price surge / demand surge in the market?"
        true-value="yes"
        false-value="no"
      ></q-checkbox>
       <q-checkbox
        v-model="future"
        color="secondary"
        label="Do you wish to get notification for future e-commerce / social events that may cause price changes? "
        true-value="yes"
        false-value="no"
      ></q-checkbox> 
      <q-checkbox
        v-model="whatsapp_updates"
        color="secondary"
        label="Do you wish to get Updates on whatsapp for a price change?"
        true-value="yes"
        false-value="no"
      ></q-checkbox>
       <q-checkbox
        v-model="terms_conditions"
        color="secondary"
        label="Do you agree with the terms & conditions of our company ?"
        true-value="yes"
        false-value="no"
      ></q-checkbox>
      <q-input
      v-model="user_text"
      filled
      autogrow
      style="border-radius:10px;background-color:white;margin-top:1.5rem;margin-left:15rem;width:300px;"
      placeholder="Do you need any other preferences? please mention?"
    ></q-input>
            </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      isAuthenticated: false,
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      notification_service: true,
      alert: "no",
      terms_conditions: "no",
      daily_update: "no",
      future: "no",
      customize_update: "no",
      whatsapp_updates: "no",
      user_text: "",
    };
  },
  mounted() {
    this.$q.loading.show({
      message: "Authenticating please wait..",
    });
    if (this.$cookies.isKey("login_authentication")) {
      let encryptedText = this.$cookies.get("login_authentication");
      const decryptedText = this.$CryptoJS.AES.decrypt(
        encryptedText,
        process.env.VUE_APP_ENCRYPTION_SECRET_KEY
      ).toString(this.CryptoJS.enc.Utf8);
      console.log("decrypt: ", decryptedText);
      if (decryptedText == "authenticated") {
        this.$q.loading.hide();
        this.$store.dispatch("setPathName", "/pricewatch/notification");
        this.isAuthenticated = true;
      } else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else if (this.$cookies.isKey("login_authentication1")) {
      let encryptedText = this.$cookies.get("login_authentication1");
      const decryptedText = this.$CryptoJS.AES.decrypt(
        encryptedText,
        process.env.VUE_APP_ENCRYPTION_SECRET_KEY
      ).toString(this.CryptoJS.enc.Utf8);
      console.log("decrypt: ", decryptedText);
      if (decryptedText == "authenticated") {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
      } else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }
    else if (this.$cookies.isKey("login_authentication2")) {
      let encryptedText = this.$cookies.get("login_authentication2");
      const decryptedText = this.$CryptoJS.AES.decrypt(
        encryptedText,
        process.env.VUE_APP_ENCRYPTION_SECRET_KEY
      ).toString(this.CryptoJS.enc.Utf8);
      console.log("decrypt: ", decryptedText);
      if (decryptedText == "authenticated") {
        this.$q.loading.hide();
        this.$store.dispatch("setPathName", "/pricewatch/notification");
        this.isAuthenticated = true;
      } else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    }

     else {
      this.$q.loading.hide();
      this.$router.push({
        name: "NotAuthenticated",
      });
      return;
    }
  },
  methods: {
    notification_submit() {
      return [
        {
          notification_service: this.notification_service,
          alert: this.alert,
          terms_conditions: this.terms_conditions,
          daily_update: this.daily_update,
          future: this.future,
          customize_update: this.customized_update,
          whatsapp_updates: this.whatsapp_updates,
          user_text: this.text,
        },
      ];
    },
    on_submit() {
      this.$mixpanel.track('pricetracker/Notifications/Save',{
        info: 'User Saved the preferences'

      })
      this.$q.loading.show({
        message: "Saving your preferences, please wait..",
      });
      let postURL = this.api_url + `/products/trigger_price_watch_notification/` + this.$org_id.label;
      this.$http.post(postURL, this.notification_submit()).then((response) => {
        console.log("absc", response);
        if (response.data) {
          this.$q.loading.hide();
          this.$alert("Preferences saved successfully.", "Great!", "success");
        } else {
          this.$q.loading.hide();
          this.$alert("Preferences could not be saved!", "Sorry", "error");
        }
      });
    },
  },
};
</script>

<style>
.head-content {
  margin-bottom: 110px;
}
.hea {
  font-size: 150px;
  text-align: center;
  color: rgb(33, 103, 233);
  font-family: "Lobster", cursive;
  font-weight: bold;
}
.toggle {
  margin-left: 0.5rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.row.reverse {
  flex-direction: row-reverse;
  margin: 21px 0;
}
.butt {
  /* margin-left: 42rem;
  margin-top: -32rem;
  margin-bottom: 3rem; */
  border-radius: 21px;
  height: 34px;
  margin-bottom: 20px;
}
.matte {
  padding-bottom: 2rem;
  margin-top: 2rem;
  padding-top: 20px;
  padding-left: 5rem;
  padding-right: 5rem;
  font-size: 15px;
  font-family: "Roboto", sans-serif;
  background-color: skyblue;
  border-radius: 10px;
  margin-left: 10rem;
  margin-right: 10rem;
  text-align: center;
}
.matter {
  padding-top: 20px;
  padding-left: 5rem;
  padding-right: 5rem;
  font-size: 15px;
  font-family: "Roboto", sans-serif;
  background-color: skyblue;
  border-radius: 10px;
  margin-left: 10rem;
  margin-right: 10rem;
  text-align: center;
}
.hea {
  font-size: 150px;
  text-align: center;
  color: rgb(33, 103, 233);
  font-family: "Lobster", cursive;
  font-weight: bold;
}
.toggle {
  margin-left: 0.5rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.row.reverse {
  flex-direction: row-reverse;
  margin: 21px 0;
  margin-top: 3em;
}
.main-card {
  background-color: white;
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;
  width: 30%;
  /* height: 50vh; */
  border-radius: 0.5rem;
  box-shadow: (0.05rem 0.1rem 0.3rem -0.03rem) rgba(0, 0, 0, 0.45);
}
.main-card img {
  width: 100%;
  /* width: 121%; */
  aspect-ratio: 1/1;
  display: block;
  border-radius: 0.5rem 0.5rem 0 0;
  object-fit: cover;
  /* object-fit: cover; */
  /* position: relative;
    left: -1.6rem;
    overflow: hidden; */
}
.para {
  display: flex;
  flex-direction: row;
  font-family: "Poppins";
  font-size: smaller;
  justify-content: space-between;
  padding: 0.75em;
  flex-grow: 0.25;
  align-items: flex-end;
}
.bottom {
  display: flex;
  flex-direction: row;
  padding-left: 0.6em;
  margin: auto 0;
}
.wrapper {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background: white;
}
.bottom > span {
  align-self: flex-end;
}
.head-content img {
  top: 3vh;
  left: -7vh;
  width: 5em;
  display: block;
  aspect-ratio: 1/1;
  border-radius: 50%;
  position: relative;
  z-index: 100;
}
.head-card {
  background-color: white;
  border-radius: 0.4rem;
  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
  padding: 1rem;
  width: min(400px, 30em);
  height: min(400px, 10em);
  margin-inline: auto;
  box-shadow: 10px 10px 32px -8px rgb(0 0 0 / 75%);
  position: absolute;
  z-index: 10;
}
/* .contaier{
  background-color: brown;
  position: relative;
    left: 9%;
        margin-top: 7em;
} */
.container {
  margin-top: 4em;
}
.head {
  font-size: smaller;
}
/* .head-img{
  content: url("https://www.pixelstalk.net/wp-content/uploads/2016/07/Desktop-autumn-hd-wallpaper-3D.jpg");
  width:1000px;
  height:1000px;
  background: pink;
  } */
.head-sub {
  display: flex;
  flex-direction: column;
}
.card-para {
  display: block;
  margin-bottom: 2vh;
  color: gray;
}
.main {
  display: grid;
  grid-template-columns: 1fr 1fr;
  background-color: #ffffff;
  /* width: 79%; */
  box-shadow: 0.05rem 0.1rem 0.3rem -0.03rem rgb(0 0 0 / 45%);
  background-image: url("../../../public/Decore.png");
  background-repeat: repeat-y;
  background-position-x: 252px;
  background-position-y: 44px;
  background-repeat: no-repeat;
  background-size: 16rem 25em;
  box-shadow: 0px 3px 6px #272d3b4f;
  border-radius: 15px;
}
.main-card {
  width: min(400px, 19em);
  margin-inline: auto;
  /* aspect-ratio: 0.9/1; */
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: min(400px, 28em);
  margin-top: 30px;
  /* background-image: url('../../../public/Decore.png'); */
}
.contaier {
  margin-inline: auto;
}
.label-heading {
  position: relative;
  top: 62px;
  visibility: hidden;
  color: gray;
}
.main {
  /* height: 674px;
  width: 1248px; */
}
.row.reverse {
  flex-direction: row-reverse;
  /* margin-top: auto; */
  margin: 21px 0;
  /* margin-top: auto; */
  margin-top: 3em;
}
.main-card {
  background-color: white;
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;
  width: 30%;
  /* height: 50vh; */
  border-radius: 0.5rem;
  box-shadow: 0.05rem 0.1rem 0.3rem -0.03rem rgba(0, 0, 0, 0.45);
}
.main-card img {
  width: 100%;
  /* width: 121%; */
  aspect-ratio: 1/1;
  display: block;
  border-radius: 0.5rem 0.5rem 0 0;
  object-fit: cover;
  /* object-fit: cover; */
  /* position: relative;
    left: -1.6rem;
    overflow: hidden; */
}
.para {
  display: flex;
  flex-direction: row;
  font-family: "Poppins";
  font-size: smaller;
  justify-content: space-between;
  padding: 0.75em;
  flex-grow: 0.25;
  align-items: flex-end;
}
.bottom {
  display: flex;
  flex-direction: row;
  padding-left: 0.6em;
  margin: auto 0;
}
.wrapper {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background: white;
}
.bottom > span {
  align-self: flex-end;
}
.head-content img {
  top: 3vh;
  left: -7vh;
  width: 5em;
  display: block;
  aspect-ratio: 1/1;
  border-radius: 50%;
  position: relative;
  z-index: 100;
}
.head-card {
  background-color: white;
  border-radius: 0.4rem;
  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
  padding: 1rem;
  width: min(400px, 30em);
  height: min(400px, 10em);
  margin-inline: auto;
  box-shadow: 10px 10px 32px -8px rgb(0 0 0 / 75%);
  position: absolute;
  z-index: 10;
}
/* .contaier{
  background-color: brown;
  position: relative;
    left: 9%;
        margin-top: 7em;
} */
.container {
  margin-top: 4em;
}
.head {
  font-size: smaller;
}
/* .head-img{
  content: url("https://www.pixelstalk.net/wp-content/uploads/2016/07/Desktop-autumn-hd-wallpaper-3D.jpg");
  width:1000px;
  height:1000px;
  background: pink;
  } */
.head-sub {
  display: flex;
  flex-direction: column;
}
.card-para {
  display: block;
  margin-bottom: 2vh;
  color: gray;
}
.main {
  display: grid;
  grid-template-columns: 1fr 1fr;
  background-color: #ffffff;
  /* width: 79%; */
  box-shadow: 0.05rem 0.1rem 0.3rem -0.03rem rgb(0 0 0 / 45%);
  background-image: url("../../../public/Decore.png");
  background-repeat: repeat-y;
  background-position-x: 252px;
  background-position-y: 44px;
  background-repeat: no-repeat;
  background-size: 16rem 25em;
  box-shadow: 0px 3px 6px #272d3b4f;
  border-radius: 15px;
}
.main-card {
  width: min(400px, 19em);
  margin-inline: auto;
  /* aspect-ratio: 0.9/1; */
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: min(400px, 28em);
  margin-top: 30px;
  /* background-image: url('../../../public/Decore.png'); */
}
.contaier {
  margin-inline: auto;
}
.label-heading {
  position: relative;
  top: 62px;
  visibility: hidden;
  color: gray;
}
.main {
  /* height: 674px;
  width: 1248px; */
}
.container {
  /* display: flex; */
  width: 100%;
  justify-content: center;
  align-items: center;
}
</style>

